var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-h-screen flex flex-col bg-oldburgundy",attrs:{"id":"app"}},[_c('db-uploader-navbar'),_c('router-view',{staticClass:"flex-grow p-8 text-2xl bg-cover bg-fixed bg-center",style:({ backgroundImage: 'url(' + require('@/assets/bg3.jpg') + ')' })}),_c('db-uploader-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }